function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M24.555 2c.907 0 1.791.282 2.527.808a4.305 4.305 0 0 1 1.591 2.166l3.218 9.314c.073.21.109.43.109.647v12.512A3.56 3.56 0 0 1 28.444 31h-1.555a3.56 3.56 0 0 1-3.53-3.128H8.641A3.562 3.562 0 0 1 5.11 31H3.556A3.56 3.56 0 0 1 0 27.447v-12.51c0-.22.036-.439.108-.646l3.227-9.34a.997.997 0 0 1 .014-.044C3.939 3.243 5.513 2 7.444 2h17.111zm1.361 2.424a2.334 2.334 0 0 0-1.359-.435H7.444a2.34 2.34 0 0 0-2.208 1.58L2 14.935v12.512c0 .86.701 1.564 1.556 1.564H5.11c.855 0 1.557-.704 1.557-1.564v-.57c0-.55.448-.995 1-.995h16.666c.552 0 1 .445 1 .995v.57c0 .86.701 1.564 1.556 1.564h1.555c.855 0 1.556-.704 1.556-1.564V14.936l-3.234-9.36a2.315 2.315 0 0 0-.85-1.152zM7.218 7.018a1 1 0 0 1 .95-.683h15.664a1 1 0 0 1 .95.683l1.674 5.047a.99.99 0 0 1-.14.895c-.188.258-.49.412-.81.412H6.494c-.32 0-.622-.154-.81-.412a.99.99 0 0 1-.14-.895l1.674-5.047zm1.673 1.306l-1.014 3.058h16.246L23.11 8.324H8.89zM7.444 18.49a.342.342 0 0 0-.333.356v.012a.339.339 0 0 0 .209.318c.04.017.084.026.128.027a.343.343 0 0 0 .33-.357.342.342 0 0 0-.334-.356zm-2.333.351a2.336 2.336 0 0 1 2.333-2.34 2.336 2.336 0 0 1 2.334 2.345c0 1.3-1.045 2.346-2.334 2.346h-.007a2.354 2.354 0 0 1-1.655-.698 2.33 2.33 0 0 1-.671-1.653zm19.445-.35c-.17 0-.334.14-.334.356v.01a.341.341 0 0 0 .337.346.343.343 0 0 0 .33-.357.342.342 0 0 0-.333-.356zm-2.334.35a2.336 2.336 0 0 1 2.334-2.34 2.336 2.336 0 0 1 2.333 2.345c0 1.3-1.045 2.346-2.333 2.346h-.007a2.352 2.352 0 0 1-1.655-.697 2.327 2.327 0 0 1-.672-1.654z",
  clipRule: "evenodd"
});

var SvgCar = function SvgCar(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "533f5201587518f92695efd09305cca7.svg";
export { SvgCar as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/car.svg
// module id = null
// module chunks = 